<template>
  <div
    v-loading="loading"
    element-loading-text="考核云正在拼命加载中"
    element-loading-spinner="el-icon-loading"
    class="content"
  >
    <div class="flex_view showlabel" v-if="$route.name != 'Paperlist'">
      <div class="flex_view">
        <h4>选择题库</h4>
        <div class="testtype">组件模式：{{ groupmode }}</div>
        <div class="testtype">命题方式：{{ unified }}</div>
      </div>
      <el-button class="explain" @click="explainPop">题型说明</el-button>
    </div>
    <!-- 难易度 -->
    <facilityPage
      v-if="groupmode === '难易度组卷' && loading == false"
      :getData="getData"
      :editState="editState"
      ref="facilitypage"
    />
    <div class="baic_content" v-else>
      <!-- 权重的表格 -->
      <div
        class="hos_table"
        v-if="
          (groupmode === '权重组卷' && $parent.iseditmode === undefined) ||
          $parent.israndom_Proportion == '1'
        "
        id="guide-page-three"
      >
        <el-form :v-model="getData">
          <el-table
            :model="getData"
            :data="getData"
            style="width: 100%"
            :summary-method="getSummaries"
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              'background-color': '#8FCBFF',
              color: '#333333',
              height: '60px',
            }"
          >
            <el-table-column type="index" label="序号" width="100">
            </el-table-column>
            <el-table-column prop="StyleName" label="题型">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.StyleName"
                  :readonly="true"
                  class="super_input"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Score" label="分值">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.Score"
                  class="small_input"
                  :maxlength="4"
                  @blur="refn(scope.row)"
                ></el-input
                >分
              </template>
            </el-table-column>
            <el-table-column prop="Explain" label="题型说明" width="430px">
              <template slot-scope="scope">
                <el-input
                  type="textarea"
                  class="long_input"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model.trim="scope.row.Explain"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == 0 }"
                  @click="onmoveup(scope.$index, scope.row)"
                  :disabled="scope.$index == 0"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == getData.length - 1 }"
                  @click="onmovedown(scope.$index, scope.row)"
                  :disabled="scope.$index == getData.length - 1"
                  >下移</el-button
                >
                <el-button type="text" @click="deletes(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="reduce">
          <p>合计：</p>
          <div>
            <p>{{ weightreducefen }}分</p>
            <p>{{ weightreducesum }}题</p>
          </div>
        </div>
      </div>
      <!-- 表单内容 -->
      <div id="guide-page-three" class="hos_table" v-else>
        <el-form :v-model="getData">
          <el-table
            :model="getData"
            :data="getData"
            style="width: 100%"
            :summary-method="getSummaries"
            show-summary
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              'background-color': '#8FCBFF',
              color: '#333333',
              height: '60px',
            }"
          >
            <el-table-column type="index" label="序号" width="100">
            </el-table-column>
            <el-table-column prop="StyleName" label="题型">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.StyleName"
                  maxlength="10"
                  class="super_input"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Total" label="题数"> </el-table-column>
            <el-table-column prop="Score" label="分值">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.Score"
                  class="small_input"
                  :maxlength="4"
                  @change="checkscore(scope.row.Score, scope.$index)"
                ></el-input
                >分
              </template>
            </el-table-column>
            <el-table-column prop="TestCount" label="题量">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.TestCount"
                  class="small_input"
                  :disabled="isjingzhun"
                  @change="checkscore(scope.row, scope.$index, 'test')"
                ></el-input
                >{{ scope.row.StyleName === "填空题" ? "题(空)" : "题" }}
              </template>
            </el-table-column>
            <el-table-column prop="Explain" label="题型说明" width="430px">
              <template slot-scope="scope">
                <el-input
                  type="textarea"
                  class="long_input"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model.trim="scope.row.Explain"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == 0 }"
                  @click="onmoveup(scope.$index, scope.row)"
                  :disabled="scope.$index == 0"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == getData.length - 1 }"
                  @click="onmovedown(scope.$index, scope.row)"
                  :disabled="scope.$index == getData.length - 1"
                  >下移</el-button
                >
                <el-button type="text" @click="deletes(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="operation">
      <el-button class="succ_btn" @click="previousstep()">上一步</el-button>
      <el-button type="success" class="submit_btn" @click="nexttothree"
        >下一步</el-button
      >
    </div>
    <!-- 弹窗 -->
    <Explain ref="explain" />
  </div>
</template>

<script>
import $guideSteps from "@/utils/guideSteps";
import $utils from "@/utils/commonUtils";
import editqusetionbank from "@/api/editqusetionbank";
import getappstyle from "@/api/questionbank";
import { getTestStyle } from "@/api/examination.js";
import transferfunc from "../../../../../../utils/transfer";
import Explain from "@/components/Explain";
import facilityPage from "./facilityPage.vue";
let sumar = transferfunc.sumar;
let tishidearr;
import loginvuex from "@/store/index";
import qs from "qs";
export default {
  name: "Pagethree",
  props: ["cutcoms"],
  data() {
    return {
      weightreducesum: 0, //权重总题数，
      weightreducefen: 0, //权重总分数
      textarea: "",
      input: "",
      readonly: true,
      isjingzhun: false, //精准模式下禁用掉分值和题型。
      loading: true,
      getData: [],
      reducesum: "", //总分
      reducetishi: "", //总题数
      addPaperData: [], // id
      addPaperLenght: [], // 题型
      groupmode: "", //组卷模式
      unified: "", //统一命题
      valueArr: [], //试卷组卷拼接参数
      driver: null,
      editState: "add",
    };
  },
  components: {
    Explain,
    facilityPage,
  },
  methods: {
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    checkscore(Score, indexs, istest) {
      // 2024/3/20 产品要求题数输入0时删除该数据 2024/11/19修改组卷和练习都删除
      const examState = sessionStorage.getItem("examState"); // 是否是组卷进入 && examState === "true"
      if (Score.TestCount == 0) {
        this.getData.splice(indexs, 1);
        // 题量为0返回重新选择
        if (this.getData.length < 1) {
          this.cutcoms(1);
        }
      }
      // else if (Score.TestCount == 0 || Score.TestCount == "") {
      //   Score.TestCount = 0;
      //   this.$message({
      //     message: "警告，当前题型数量为0，请添加试题",
      //     type: "warning",
      //   });
      // }
      if (istest == "test") {
        if (isNaN(Number(Score.TestCount))) {
          this.getData[indexs].TestCount = "";
          this.$message({
            showClose: true,
            message: "请输入正确的题量值",
            type: "error",
          });
        } else if (Number(Score.TestCount) > Score.Total) {
          this.getData[indexs].TestCount = "";
          this.$message({
            showClose: true,
            message: `题量不能大于该题型${Score.StyleName}的总题量:${Score.Total}`,
            type: "error",
          });
        }
        return;
      }
      //检查分数范围。
      if (isNaN(Number(Score))) {
        this.getData[indexs].Score = "";
        this.$message({
          showClose: true,
          message: "请输入正确的分数值",
          type: "error",
        });
      } else if (Number(Score) > 99) {
        this.getData[indexs].Score = "";
        this.$message({
          showClose: true,
          message: "分数不能大于99",
          type: "error",
        });
      }
    },
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = []; //循环数组加算的数字
      let value3 = []; //这里是分数的数组
      let value4 = []; //这里是题数的数组
      let reducesum = [];
      let news = [];
      let newstishu = "";
      columns.forEach((column, index) => {
        if (index === 2) {
          sums[index] = "合计";
          return;
        }
        const value = data.map((item) => Number(item[column.property]));
        if (index === 3) {
          value3 = JSON.stringify(value);
          value3 = JSON.parse(value3);
        } else if (index === 4) {
          value4 = JSON.stringify(value);
          value4 = JSON.parse(value4);
          reducesum = value3.map((ztiem, zindex) => {
            return ztiem * value4[zindex];
          });
          news = reducesum.reduce((total, num) => {
            return Number(total) + Number(num);
          }, 0);
          newstishu = value4.reduce((totals, nums) => {
            return Number(totals) + Number(nums);
          }, 0);
          this.reducesum = news;
          this.$parent.reducesum = news;
          sums[index - 1] = news;
          sums[index - 1] += "分";
          sums[index] = newstishu;
          this.reducetishi = newstishu;
          sums[index] += "题";
        }
      });
      return sums;
    },
    // 上移
    onmoveup(index, row) {
      var that = this;
      if (index > 0) {
        let upDate = that.getData[index - 1];
        that.getData.splice(index - 1, 1);
        that.getData.splice(index, 0, upDate);
      } else {
        alert("已经是第一条，不可上移");
      }
    },
    onmovedown(index, row) {
      var that = this;
      if (index + 1 === that.getData.length) {
        alert("已经是最后一条，不可下移");
      } else {
        let downDate = that.getData[index + 1];
        that.getData.splice(index + 1, 1);
        that.getData.splice(index, 0, downDate);
      }
    },
    previousstep() {
      if (this.$parent.iseditmode !== undefined) {
        //编辑模式下
        this.cutcoms(1);
        return;
      }
      if (
        this.$parent.testmode === "智能组卷" ||
        this.$parent.testmode === "难易度组卷"
      ) {
        this.cutcoms(1);
      } else if (this.$parent.testmode === "试卷组卷") {
        this.cutcoms(1.1);
      } else if (this.$parent.testmode === "精准组卷") {
        this.cutcoms(1.2);
      } else if (this.$parent.testmode === "权重组卷") {
        this.cutcoms(1.3);
      }
    },
    destory() {
      this.$destroy();
    },
    // 智能组卷第二页获取系统分类历史
    async getDateList(quest) {
      let params = {
        config: `${quest}`,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await getappstyle.getappstyle(params);
      if (Data.status == 200) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        Data.data.Data.forEach((item) => {
          item.TestCount =
            item.TestCount > item.Total ? item.Total : item.TestCount;
        });
        this.getData = Data.data.Data;
      } else {
        this.$message.error("数据获取不到");
      }
    },
    //精准组卷第二页的分类历史
    async getDateaccurateList(quest) {
      let params = {
        SelectTestArr: `${quest}`,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const Data = await getappstyle.getAppStyle(params);
      if (Data.status == 200) {
        this.loading = false;
        this.getData = Data.data.Data;
      } else {
        this.$message.error("数据获取不到");
      }
    },
    // 获取试卷组卷
    async getPaper() {
      let PaperArr = this.$parent.PaperStyleArr;
      // if (this.$parent.iseditmode !== undefined) {
      //   // console.log("this.$parent.iseditmode=====", this.$parent.iseditmode);
      //   // 如果获取新的试卷ID，重新调用一下编辑接口赋值
      //   this.getData = JSON.parse(
      //     this.$parent.paperinfomation[1].Config
      //   ).Style[1];

      //   //这里要写判断，是否跟原有试卷id一致，一致就取这个，不一致重新取就可以了，还有问题吗，。
      // } else {
      this.addPaperData = [];
      this.addPaperLenght = [];
      PaperArr.map((item) => {
        this.addPaperData.push(item.PaperStyleID);
        this.addPaperLenght.push(
          `${item.label + "(" + item.TestCount + "题" + ")"}`
        );
      });
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        paperStyleData: JSON.stringify(this.addPaperData),
        paperStyleArr: JSON.stringify(this.addPaperLenght),
        testShowCount: -1,
      };
      const Data = await getTestStyle(params);
      if (Data.status == 200) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.getData = Data.data.Data;
      } else {
        this.$message.error("数据获取不到");
      }
      // }
    },
    // 获取难易度组卷
    async getdifficalArr(quest) {
      this.loading = true;
      const params = {
        config: `${quest}`,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await getappstyle.getdifficalArr(params);
      if (data.Status == 200) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.getData = data.Data.map((item) => {
          item.num = 0;
          item.Explain = "";
          return item;
        });
      } else {
        this.$message.error(data.Msg || data.Data);
      }
    },
    // 获取权重组卷
    async getWeight() {
      this.getData = this.$parent.pageStyelArr;
      this.weightreducefen = this.$parent.pageStyelArr[0]["weightreducefen"];
      this.weightreducesum = this.$parent.pageStyelArr[0]["weightreducesum"];
      this.loading = false;
    },
    // 正整数正则校验
    refn(res) {
      // let reg = /^[1-9]\d*$/; //可以设置0.5分的
      // if (!reg.test(Number(res.Score))) {
      //   this.$message({
      //     message: "只能输入正整数",
      //     type: "warning",
      //   });
      //   res.Score = 1;
      //   return;
      // }
      //权重输入框修改后的更改。
      //这里的逻辑：1拿到题的类型，遍历styleAllArr里面的源数据进行更改。用this.$parent获取直接修改
      //2修改后，重新执行一次pagethressrefn方法,拿到计算后的总分和总题数。
      //再覆盖一次。      this.weightreducesum = this.$parent.pageStyelArr[0]['weightreducesum']
      //这里暂时修改，
      if (this.$parent.$children[2].styleAllArr == undefined) {
        this.$parent.$children[1].styleAllArr.map((item) => {
          item.children.map((zitem) => {
            if (zitem.StyleName == res.StyleName) {
              zitem.Score = res.Score;
            }
          });
        });
        this.$parent.$children[1].pagethressrefn();
        this.weightreducesum =
          this.$parent.random_Proportion_data.pageStyelArr[0][
            "weightreducesum"
          ];
        this.weightreducefen =
          this.$parent.random_Proportion_data.pageStyelArr[0][
            "weightreducefen"
          ];
        return;
      }
      this.$parent.$children[2].styleAllArr.map((item) => {
        item.children.map((zitem) => {
          if (zitem.StyleName == res.StyleName) {
            zitem.Score = res.Score;
          }
        });
      });
      this.$parent.$children[2].pagethressrefn();
      this.weightreducesum = this.$parent.pageStyelArr[0]["weightreducesum"];
      this.weightreducefen = this.$parent.pageStyelArr[0]["weightreducefen"];
    },
    nexttothreeweight() {
      //权重组卷下一步的内容。拼出Style里面的内容，还存在问题。
      let TotalArr = {
        Score: this.weightreducefen,
        Total: this.weightreducesum,
        ShowCount: -1,
      };
      this.$parent.DroitArr["1"] = TotalArr; // 权重组卷的DroitArr数据
      let tempSelect = this.$parent.DroitArr["0"].map((item) => {
        return item.cpt;
      });
      this.$parent.tempSelectCptArray = tempSelect;
      let G_SlectedObj = {}; //权重第四部需要的数据G_SlectedTestHt
      tempSelect.map((item) => {
        for (let key in item) {
          if (G_SlectedObj[key] === undefined) {
            G_SlectedObj[key] = item[key];
          } else {
            if (item[key] !== undefined) {
              G_SlectedObj[key] = item[key].concat(G_SlectedObj[key]);
            }
          }
        }
      });
      this.$parent.G_SlectedTestHt = G_SlectedObj;
      let weightPage = {};
      weightPage["0"] = {
        Score: this.weightreducefen,
        Total: this.weightreducesum,
        ShowCount: -1,
      };
      // 权重组卷传递的参数 style数据
      weightPage["1"] = this.getData;
      this.$parent.weightThreereq = weightPage; // 权重组卷的style数据
      this.$parent.reducesum = this.weightreducefen;
      this.cutcoms(3);
      this.destory();
    },
    async nexttothree() {
      //新增。题数题量校验.
      if (
        this.$parent.testmode == "难易度组卷" ||
        this.$parent.testinfomation?.PaperMode == "random_difflever" ||
        this.$parent.testinfomation?.PaperMode == "unified_difflever"
      ) {
        // 难易度组卷拦截
        let newobj = {};
        let isscore = this.getData.every((item) => {
          // 分数不能为0，总题数不能为0 题数为0分数不能填写
          if (newobj[item.StyleName] === undefined) {
            newobj[item.StyleName] = "1";
          } else {
            this.$message.error("请不要输入相同的题型名称");
            return false;
          }
          if (item.StyleName === "") {
            this.$message.error("请输入正确的题目名称");
            return false;
          } else if (
            (item.easyTestcount > 0 ||
              item.mindleTestcount > 0 ||
              item.hardTestcount > 0) &&
            item.Score <= 0
          ) {
            this.$message.error("当前有题型分数为0");
            return false;
          } else {
            return true;
          }
        });
        if (this.$refs.facilitypage.numberamount <= 0) {
          this.$message.error("当前总题数为0");
          return;
        }
        // 过滤掉垃圾数据
        this.getData = this.getData.filter((item) => {
          item.num =
            Number(item.easyTestcount) +
            Number(item.mindleTestcount) +
            Number(item.hardTestcount);
          if (item.num !== 0) {
            return item;
          }
        });
        if (!isscore) {
          return;
        }
      } else {
        let isscore = this.getData.every((item) => {
          if (item.Score === "" || isNaN(Number(item.Score))) {
            this.$message.error("请输入正确的分值");
            return false;
          } else if (item.StyleName === "") {
            this.$message.error("请输入正确的题目名称");
            return false;
          } else {
            return true;
          }
        });
        let newobj = {};
        this.getData.forEach((item) => {
          if (newobj[item.StyleName] === undefined) {
            newobj[item.StyleName] = "1";
          } else {
            this.$message.error("请不要输入相同的题型名称");
            isscore = false;
          }
        });
        if (!isscore) {
          return;
        }
      }
      if (this.$parent.iseditmode !== undefined) {
        //以下是编辑模式下的数据。
        if (
          this.$parent.testinfomation.PaperMode == "unified_db" ||
          this.$parent.testinfomation.PaperMode == "unified_exam" ||
          this.$parent.testinfomation.PaperMode == "sg_db" ||
          this.$parent.testinfomation.PaperMode == "unified_Proportion" ||
          this.$parent.testinfomation.PaperMode == "paper"
        ) {
          //统一模式下匹配第三页的数据。
          let styledata = {};
          styledata["0"] = {
            Score: this.reducesum,
            Total: this.reducetishi,
            ShowCount: "-1",
          };
          this.getData.map((item) => {
            item["OldStyleName"] = item.OldStyleName
              ? item.OldStyleName
              : item.StyleName;
          });
          //  this.getData.map((item) => {
          //   item["Total"] = 0;
          // });
          styledata["1"] = this.getData;
          this.$parent.Style = styledata;
          //  this.$parent.reducesum = this.reducesum;
          let styledataarr = [];
          styledataarr[0] = {
            Score: this.reducesum,
            Total: this.reducetishi,
            ShowCount: "-1",
          };
          styledataarr[1] = this.getData;
          this.$parent.paper_data.config = styledataarr;
          this.$parent.paper_data.oldStyle = styledata;
        } else if (this.$parent.testinfomation.PaperMode == "random_db") {
          //随机模式下匹配第三页的数据
          let styledata = [];
          styledata[0] = {
            Score: this.reducesum,
            Total: this.reducetishi,
            ShowCount: "-1",
          };
          this.getData.map((item) => {
            item["OldStyleName"] = item.OldStyleName
              ? item.OldStyleName
              : item.StyleName;
          });
          styledata["1"] = this.getData;
          this.$parent.random_db_data.Style = styledata;
        } else if (
          this.$parent.testinfomation.PaperMode == "random_Proportion"
        ) {
          //权重随机
          let styledata = {};
          styledata["0"] = {
            Score: this.weightreducefen,
            Total: this.weightreducesum,
            ShowCount: "-1",
          };
          this.getData.map((item) => {
            item["OldStyleName"] = item.OldStyleName
              ? item.OldStyleName
              : item.StyleName;
          });
          styledata["1"] = this.getData;
          this.$parent.random_Proportion_data.Style = styledata;
          this.$parent.reducesum = this.weightreducefen;
          let TotalArr = {
            Score: this.weightreducefen,
            Total: this.weightreducesum,
            ShowCount: -1,
          };
          this.$parent.random_Proportion_data.DroitArr["1"] = TotalArr;

          let tempSelect = this.$parent.random_Proportion_data.DroitArr[
            "0"
          ].map((item) => {
            return item.cpt;
          });
          this.$parent.random_Proportion_data.tempSelectCptArray = tempSelect;
          let G_SlectedObj = {}; //权重第四部需要的数据G_SlectedTestHt
          tempSelect.map((item) => {
            for (let key in item) {
              if (G_SlectedObj[key] === undefined) {
                G_SlectedObj[key] = item[key];
              } else {
                if (item[key] !== undefined) {
                  G_SlectedObj[key] = item[key].concat(G_SlectedObj[key]);
                }
              }
            }
          });
          this.$parent.random_Proportion_data.G_SlectedTestHt = G_SlectedObj;
        } else if (this.$parent.testinfomation.PaperMode == "random_exam") {
          let pagethree = [
            // 试卷组卷随机组卷传递的参数
            {
              Score: this.reducesum,
              Total: this.reducetishi,
              ShowCount: -1,
            },
          ];
          this.getData.map((item) => {
            item["OldStyleName"] = item.OldStyleName
              ? item.OldStyleName
              : item.StyleName;
          });
          pagethree.push(this.getData);
          this.$parent.random_exam_data.Style = pagethree;
        }
        if (this.$parent.testinfomation.PaperMode == "paper") {
          this.$parent.savemodifystyle();
          this.$parent.back();
          this.$message.success("保存成功");
          return;
        }

        if (
          this.$parent.testinfomation.PaperMode === "unified_difflever" ||
          this.$parent.testinfomation.PaperMode === "random_difflever"
        ) {
          // 编辑难易度
          let styledata = {};
          styledata["0"] = {
            Score: this.$parent.reducesum,
            Total: this.$refs.facilitypage.numberamount,
            ShowCount: "-1",
          };
          this.getData.map((item) => {
            item["OldStyleName"] = item.OldStyleName
              ? item.OldStyleName
              : item.StyleName;
          });
          styledata["1"] = this.getData;
          this.$parent.Style = styledata;
          let styledataarr = [];
          styledataarr[0] = {
            Score: this.$parent.reducesum,
            Total: this.$refs.facilitypage.numberamount,
            ShowCount: "-1",
          };
          styledataarr[1] = this.getData;
          this.$parent.paper_data.config = styledataarr;
          this.$parent.paper_data.oldStyle = styledata;
          if (this.$parent.testinfomation.PaperMode === "random_difflever") {
            // 随机命题
            this.$parent.random_db_data.Style = styledata;
          }
        }
        this.cutcoms(3);
        return;
        //编辑模式下跳转
      }
      if (this.groupmode === "权重组卷") {
        this.nexttothreeweight();
        return;
      }
      let pagethree = [
        // 智能组卷传递的参数
        {
          Score:
            this.$parent.testmode === "难易度组卷"
              ? this.$parent.reducesum
              : this.reducesum,
          Total:
            this.$parent.testmode === "难易度组卷"
              ? this.$refs.facilitypage.numberamount
              : this.reducetishi,
          ShowCount: -1,
        },
      ];

      let examPage = [
        // 试卷组卷传递的参数
        {
          Score: this.reducesum,
          Total: this.reducetishi,
          ShowCount: -1,
        },
      ];
      examPage.push(this.getData);
      // weightPage.push(this.getData);
      this.$parent.examThreereq = examPage; // 试卷组卷的style数据
      let PaperStyleID = [];
      this.getData.map((item) => {
        if (item.PaperStyleID instanceof Array) {
          PaperStyleID = PaperStyleID.concat(item.PaperStyleID);
        } else if (item.PaperStyleID instanceof String) {
          PaperStyleID.push(item.PaperStyleID);
        }
      });
      this.$emit("setExamValue", this.valueArr);
      this.$emit("setExamPage", PaperStyleID);
      pagethree.push(this.getData);
      this.$parent.pagethreereq = pagethree;
      //进行智能组卷校验
      if (
        this.$parent.testmode === "智能组卷" ||
        this.$parent.testmode === "难易度组卷"
      ) {
        this.smartpapaer();
      }
      if (this.$parent.testmode === "精准组卷") {
        this.cutcoms(3);
      }
      if (this.$parent.testmode === "试卷组卷") {
        this.cutcoms(3);
      }
    },
    //智能组卷校验方法
    async smartpapaer() {
      //如果没有填空题和B题型，A3题型，绕开校验。
      this.cutcoms(3);
      return;
    },
    //删除操作
    deletes(index) {
      this.$confirm("确认删除当前题型吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.getData.splice(index, 1);
          if (this.getData.length < 1) {
            this.cutcoms(1);
          }
        })
        .catch(() => {});
    },
    getpaperstlye() {
      this.groupmode = this.$parent.testmode;
      this.unified = this.$parent.checkmode;
      let questdata = JSON.stringify(this.$parent.pagetwodata);
      if (this.$parent.testmode === "智能组卷") {
        this.isjingzhun = false;
        this.getDateList(questdata);
      } else if (this.$parent.testmode === "试卷组卷") {
        this.getPaper();
        this.isjingzhun = false;
      } else if (this.$parent.testmode === "精准组卷") {
        this.isjingzhun = true;
        this.getDateaccurateList(questdata);
      } else if (this.$parent.testmode === "权重组卷") {
        this.getWeight();
      } else if (this.$parent.testmode === "难易度组卷") {
        this.getdifficalArr(questdata);
      }
    },
    geteditpaperstlye() {
      //编辑模式下获取组卷。
      this.groupmode = this.$parent.testinfomation.PaperModeExam; //组卷模式
      this.unified = this.$parent.testinfomation.PaperModeName; //组卷方式
      console.log(
        "groupmode=====组卷模式",
        this.groupmode,
        this.$parent.testinfomation.PaperMode
      );
      // console.log("unified=====组卷方式", this.unified);
      if (
        this.$parent.testinfomation.PaperMode == "unified_db" ||
        this.$parent.testinfomation.PaperMode == "unified_exam" ||
        this.$parent.testinfomation.PaperMode == "sg_db" ||
        this.$parent.testinfomation.PaperMode == "unified_Proportion" ||
        this.$parent.testinfomation.PaperMode == "paper"
      ) {
        this.getunified_db();
        if(sessionStorage.getItem('examState')){
        this.isjingzhun = true; // 编辑模式练习禁用
        }
      } else if (
        this.$parent.testinfomation.PaperMode === "unified_difflever" ||
        this.$parent.testinfomation.PaperMode === "random_difflever"
      ) {
        // 难易度
        this.getStyleFeedback();
      } else if (this.$parent.testinfomation.PaperMode == "random_db") {
        this.getrandom_db_data();
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else if (this.$parent.testinfomation.PaperMode == "random_Proportion") {
        this.getrandom_Proportion();
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else if (this.$parent.testinfomation.PaperMode == "random_exam") {
        this.getPaper();
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }
    },
    // 难易度回显
    async getStyleFeedback() {
      this.loading = true;
      if (this.$parent.testinfomation.PaperMode === "unified_difflever") {
        // 编辑统一组卷才禁用输入框
        this.editState = "edit";
        const parmas = {
          _examID: this.$parent.testinfomation.ExamID,
        };
        const { data } = await editqusetionbank.getFeedbackStyle(parmas);
        if (data.Status == 200) {
          // console.log(JSON.parse(data.Data).Style,'???');
          data.Data = JSON.parse(data.Data);
          this.getData = data.Data.Style[1];
          // this.$refs.facilitypage.numberamount = data.Data.Style[0].Total
          // this.$refs.facilitypage.scoreTotal = data.Data.Style[0].Score
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.$message.error(data.Data + data.Msg);
        }
      }else{
        // 随机
        const params = {
        config: JSON.stringify(this.$parent.random_db_data.CookieCpt),
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await getappstyle.getdifficalArr(params);
      if (data.Status == 200) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.getData = data.Data;
      } else {
        this.$message.error(data.Msg || data.Data);
      }
      }
     
    },
    async getunified_db() {
      //编辑统一第三步;
      let parmas = {
        paperID: this.$parent.testinfomation.PaperID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: this.$parent.testinfomation.ExamID,
      };
      let res = await editqusetionbank.getPaperStyle(parmas);
      console.log(res, "???");
      if (res.data.Status == 200) {
        this.getData = res.data.Data;
        this.getData.map((item) => {
          item.Total = item.TestCount;
        });
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(res.data.Msg || res.data.Data);
      }
    },
    async getrandom_db_data() {
      if (!this.$parent.random_db_data.editChangeScope) {
        this.getData = JSON.parse(
          this.$parent.paperinfomation[1].Config
        ).Style[1];
        return;
      }
      //智能随机
      let parmas = {
        paperID: this.$parent.testinfomation.PaperID,
        config: JSON.stringify(this.$parent.random_db_data.CookieCpt),
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: this.$parent.testinfomation.ExamID,
      };
      const Data = await getappstyle.getappstyle(parmas);
      if (Data.status == 200) {
        //  this.loading = false;
        setTimeout(() => {
          this.loading = false;
        }, 500);
        Data.data.Data.forEach((item) => {
          item.TestCount =
            item.TestCount > item.Total ? item.Total : item.TestCount;
        });
        this.getData = Data.data.Data;
      } else {
        this.$message.error("数据获取不到");
      }
    },
    async getrandom_Proportion() {
      this.getData = this.$parent.random_Proportion_data.pageStyelArr;
      this.weightreducefen =
        this.$parent.random_Proportion_data.pageStyelArr[0]["weightreducefen"];
      this.weightreducesum =
        this.$parent.random_Proportion_data.pageStyelArr[0]["weightreducesum"];
    },
    // 题型说明
    explainPop() {
      this.$refs.explain.show3 = true;
    },
  },
  async activated() {
    // console.log("进入了pagethree",this.$parent.iseditmode);
    if (this.$parent.iseditmode !== undefined) {
      //编辑模式下
      // console.log("编辑模式下", this.loading, this.$parent.isnewtestaas);
      if (this.$parent.isnewtestaas == 1) {
        // console.log("不刷新");
        this.loading = true;
        this.geteditpaperstlye();
        this.$parent.isnewtestaas = 0;
      }
      return;
    }
    // console.log("编辑不能执行治理", this.$parent.isnewtestaas);
    if (this.$parent.isnewtestaas == 1) {
      this.getpaperstlye();
      this.$parent.isnewtestaas = 0;
    }
    if (this.$parent.testmode === "权重组卷") {
      this.getpaperstlye();
    }
    if (this.$parent.testmode !== "难易度组卷") {
      let guideSteps = await $utils.getUserGuideList("zxksPageThreeSteps");
      // console.log("guideSteps=========", guideSteps);
      this.driver = $utils.getGuideDriver();
      setTimeout(() => {
        this.$nextTick(() => {
          $utils.initGuideDriver(this.driver, guideSteps);
        });
      }, 1000);
    }
  },
};
</script>

<style lang="scss" scoped>
.showlabel {
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 50px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
}
.baic_content {
  background-color: white;
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 4px 4px 4px 4px;
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 4px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}

.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0 100px 0;
  background-color: #fff;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.small_input {
  width: 60px !important;
  height: 32px !important;
  font-size: 15px !important;
  margin-right: 10px;
}
.super_input {
  width: 100px !important;
  height: 32px !important;
  font-size: 15px !important;
  > ::v-deep .el-input__inner {
    padding: 0px 8px !important;
    text-align: center;
  }
}
.long_input {
  width: 420px;
  height: 100%;
}
::v-deep .el-input > .el-input__inner {
  height: 32px !important;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(7) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}
::v-deep.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
::v-deep .has-gutter {
  height: 70px;
  tr > td {
    background-color: #f5faff;
  }

  .cell {
    text-align: center;
  }
}
.nomove {
  opacity: 0;
  cursor: auto;
}
.reduce {
  height: 80px;
  background-color: #b7dcff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  p:nth-child(1) {
    margin-left: 30px;
  }
  div {
    display: flex;
    height: 80px;
    line-height: 80px;
    p {
      text-align: center;
      &:nth-child(1) {
        width: 60px;
      }
      &:nth-child(2) {
        width: 120px;
      }
    }
  }
}
::v-deep .el-table__body-wrapper {
  height: 548px;
  overflow-y: scroll;
}
.hos_table {
  position: relative;
}
.flex_view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.explain {
  margin-right: 24px;
  background: #1890ff;
  color: #fff;
}
.content {
  position: relative;
}
</style>
